// extracted by mini-css-extract-plugin
export var aggregationCell = "_52-p";
export var aggregationRow = "_52-o";
export var borderlessSpinnerContainer = "_52-3";
export var cardLayout = "_52-6";
export var cardLayoutNoFooter = "_52-a";
export var cardLayoutPageControl = "_52-9";
export var cardLayoutWithFooter = "_52-8";
export var closeIcon = "_52-h";
export var columnHeaderSurface = "_52-d";
export var columnHeaderSurfaceDragOverlay = "_52-x";
export var columnHeaderSurfaceResizing = "_52-u";
export var contextMenuAnchor = "_52-1";
export var draggableColumnHeader = "_52-v";
export var draggableColumnHeaderOverlay = "_52-w";
export var expandIcon = "_52-i";
export var expanded = "_52-j";
export var filterDropdown = "_52-k";
export var filterDropdownDivider = "_52-f";
export var filterDropdownHeader = "_52-n";
export var filterDropdownItem = "_52-m";
export var filterDropdownModal = "_52-l _52-k";
export var filterItem = "_52-e";
export var normalCellWithAdjustableBorder = "_52-g";
export var pinButtonContainer = "_52-q";
export var pinIcon = "_52-r";
export var pinIconActive = "_52-s";
export var spinner = "_52-0";
export var spinnerContainer = "_52-2";
export var tableContainer = "_52-4";
export var tableContentDraggingColumns = "_52-c";
export var tableContentInner = "_52-7";
export var tableContentInnerFill = "_52-b";
export var tableContentWrapper = "_52-5";
export var viewButtonContainer = "_52-t";